import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  CalendarModule as AngularCalendarModule,
  DateAdapter
} from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { NgxPermissionsModule } from 'ngx-permissions';
import { AccordionModule } from 'primeng/accordion';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { ChartModule } from 'primeng/chart';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { DropdownModule } from 'primeng/dropdown';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { TagModule } from 'primeng/tag';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { DragDropListModule } from 'src/app/components/drag-drop-list/drag-drop-list.module';
import { AppTableModule } from 'src/app/components/table/app-table.module';
import { FinancialRoutingModule } from './financial-routing.module';
import { CobrancasRecorrentesComponent } from './itau-dashboard/cobrancas-recorrentes/cobrancas-recorrentes.component';
import { CobrancasComponent } from './itau-dashboard/cobrancas/cobrancas.component';
import { ItauDashboardComponent } from './itau-dashboard/itau-dashboard.component';
import { CobrancasRecorrentesModalComponent } from './itau-dashboard/recorrencias/cobrancas-recorrentes-modal/cobrancas-recorrentes-modal.component';
import { RecorrenciasComponent } from './itau-dashboard/recorrencias/recorrencias.component';
import { WebhooksComponent } from './itau-dashboard/webhooks/webhooks.component';
import { PaymentRoundErrorReportComponent } from './scheduler-jobs/payment-round-error-report/payment-round-error-report.component';
import { PaymentRoundReportModalComponent } from './scheduler-jobs/payment-round-report-modal/payment-round-report-modal.component';
import { SchedulerJobsConfigComponent } from './scheduler-jobs/scheduler-jobs-config/scheduler-jobs-config.component';
import { SchedulerJobsPaymentRoundsComponent } from './scheduler-jobs/scheduler-jobs-payment-rounds/scheduler-jobs-payment-rounds.component';
import { SchedulerJobsPixReportComponent } from './scheduler-jobs/scheduler-jobs-pix-report/scheduler-jobs-pix-report.component';
import { SchedulerJobsComponent } from './scheduler-jobs/scheduler-jobs.component';
import { TaxPriceComponent } from './tax-price/tax-price.component';

@NgModule({
  declarations: [
    TaxPriceComponent,
    ItauDashboardComponent,
    RecorrenciasComponent,
    CobrancasComponent,
    WebhooksComponent,
    CobrancasRecorrentesComponent,
    CobrancasRecorrentesModalComponent,
    SchedulerJobsComponent,
    SchedulerJobsConfigComponent,
    SchedulerJobsPixReportComponent,
    SchedulerJobsPaymentRoundsComponent,
    PaymentRoundReportModalComponent,
    PaymentRoundErrorReportComponent
  ],
  imports: [
    CommonModule,
    FinancialRoutingModule,
    InputNumberModule,
    TableModule,
    FormsModule,
    AppTableModule,
    TabViewModule,
    ReactiveFormsModule,
    InputTextModule,
    ButtonModule,
    ToastModule,
    TooltipModule,
    ConfirmPopupModule,
    ChartModule,
    DropdownModule,
    DragDropModule,
    DragDropListModule,
    AccordionModule,
    CalendarModule,
    InputSwitchModule,
    InputGroupModule,
    InputGroupAddonModule,
    NgxPermissionsModule.forChild(),
    AngularCalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    }),
    MessageModule,
    TagModule,
    DynamicDialogModule
  ],
  providers: [ConfirmationService, MessageService, DialogService]
})
export class FinancialModule {}
